import React from 'react';

import PlsWaitScreen from '../PlsWaitScreen/PlsWait';
import MultipleChoiceResults from './MultipleChoiceResults/MultipleChoiceResults';
import TextAnswerResults from './TextAnswerResults/TextAnswerResults';

export default class ShowResults extends React.Component {
    render() {
        let {question} = this.props;

        switch (question.answer_type) {
            case 'options':
                return <MultipleChoiceResults {...this.props} />;
            case 'text':
                return <TextAnswerResults {...this.props} />;
            default:
                return <PlsWaitScreen {...this.props} />;
        }
    }
}
